<div class="preview-button" fxLayout fxLayoutGap="10px">
  <ng-container matColumnDef="viewContent">
    <a mat-button color="primary" class="view-content" (click)="viewContent()" [attr.title]="'View email content'">
      <mat-icon>visibility</mat-icon> Preview</a
    >
  </ng-container>
</div>
